import WeiLabel from './WeiLabel';

export default WeiLabel;
